import { useMemo } from 'react';

import { usePublicWorkspace } from '~/components/PublicWorkspaceProvider';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useHideAirLogo } from '~/hooks/useHideAirLogo';
import { useAccountContext } from '~/providers/AccountProvider';

/**
 * Whether the public share-link viewer should show the "Sign up for Air" CTA. Hidden for
 * logged-in accounts, for workspaces on the `hideShortUrlSignUpButton` flag, and — since the CTA
 * is Air branding — whenever `presentationSettings.hideAirLogo` is set (#8004 / #8036). Must be
 * called within a `ShortIdProvider`.
 */
export const useShowPublicSignUpButton = (): { showSignUpButton: boolean } => {
  const { workspaceId } = usePublicWorkspace();
  const { data: account } = useAccountContext();
  const { hideShortUrlSignUpButton } = useFeatureFlags();
  const { hideAirLogo } = useHideAirLogo();

  const shouldHideSignUpButton = useMemo(
    () => hideShortUrlSignUpButton?.includes(workspaceId),
    [hideShortUrlSignUpButton, workspaceId],
  );

  return { showSignUpButton: !account && !shouldHideSignUpButton && !hideAirLogo };
};
